import { render, staticRenderFns } from "./EmailWindow.vue?vue&type=template&id=3b9788cd&"
import script from "./EmailWindow.vue?vue&type=script&lang=js&"
export * from "./EmailWindow.vue?vue&type=script&lang=js&"
import style0 from "./EmailWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmailWindow.vue"
export default component.exports